import { Controller } from 'stimulus'

// The layout's time zone prompt slot, rendered once the user's zone is set.
// Asks the server whether the browser's zone keeps a different clock from the
// profile zone; if so, shows the returned prompt. "Use" saves the browser's
// zone and shows the returned confirmation in its place (no reload, so nothing
// typed on the page is lost); "Keep" closes the prompt until the browser
// reports yet another zone.
export default class extends Controller {
  connect() {
    try {
      this.zone = Intl.DateTimeFormat().resolvedOptions().timeZone
    } catch (e) {
      return
    }
    if (!this.zone || this.zone === this.data.get('checked')) return

    fetch(`${this.data.get('url')}?browser=${encodeURIComponent(this.zone)}`, {
      credentials: 'same-origin',
      headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(response => this.fragment(response))
      .then((html) => {
        if (!html) return
        this.element.innerHTML = html
        this.element.hidden = false
      })
      .catch(() => {})
  }

  use() {
    this.disable(true)
    this.post(this.data.get('acceptUrl'))
      .then(response => this.fragment(response))
      .then((html) => {
        if (html) {
          this.element.innerHTML = html
        } else {
          this.element.hidden = true
        }
      })
      .catch(() => this.disable(false))
  }

  keep() {
    this.element.hidden = true
    this.post(this.data.get('keepUrl')).catch(() => {})
  }

  post(url) {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'X-CSRF-Token': meta ? meta.content : '',
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        Accept: 'text/html'
      },
      body: JSON.stringify({ browser: this.zone })
    })
  }

  // Only a direct 200 is a fragment. fetch follows redirects, and a redirect
  // (sign-in page, forced password change) would land a whole page here.
  fragment(response) {
    return response.status === 200 && !response.redirected ? response.text() : null
  }

  disable(flag) {
    this.element.querySelectorAll('button').forEach(button => button.toggleAttribute('disabled', flag))
  }
}
